import { Box, useTheme } from "@mui/material";
import ForgotPasswordForm from "../forms/ForgotPasswordForm";

const ForgotPasswordWrapper = () => {
  const theme = useTheme();
  const colors = theme.palette;

  return (
    <ForgotPasswordForm />
  );
};

export default ForgotPasswordWrapper;
